import { FC } from "react"
import { useSelector } from "react-redux"
import { Switch } from "antd"
import {
  IPreferencesMenuItem,
  IStateRequestUpdate,
  PreferencesMenuTypeEnum
} from "Data/interfaces/Preferences/IPreferences"
import Select from "Components/UI/Select"
import { hasSelectNotificationsOptions } from "Components/UI/PreferencesModal/useOptions"
import { getTheme } from "Store/MultiDomain/MultiDomain.selector"
import { Container, Content } from "./styles"

interface ICheckAndSelectTableItem {
  activeType: PreferencesMenuTypeEnum
  itemParentId: string
  item: IPreferencesMenuItem
  index: number
  hasChecked: boolean
  onStateUpdate: (values: IStateRequestUpdate) => void
}

const CheckAndSelectTableItem: FC<ICheckAndSelectTableItem> = ({
  activeType,
  itemParentId,
  item,
  index,
  hasChecked,
  onStateUpdate
}) => {
  const theme = useSelector(getTheme)

  const handleUpdate = (
    valueId: string,
    value: boolean | string,
    selectType?: string
  ) => {
    onStateUpdate({
      Type: activeType,
      itemParentId: itemParentId,
      itemChildrenId: item.Id,
      valueId: valueId,
      value: value,
      selectType: selectType
    })
  }

  return (
    <Container>
      <Content>
        <div className="contentTitle">
          {item.Title}
        </div>
        {item.Items?.map(itemChildren => (
          <div key={itemChildren.Id}>
            <div className="row">
              <span className="rowText">
                {hasChecked && (
                  <Switch
                    size="small"
                    className="antdSwitch"
                    checked={itemChildren.ValueSwitch}
                    onChange={() => handleUpdate(
                      itemChildren.Id,
                      !itemChildren.ValueSwitch,
                      itemChildren.SelectType
                        ? hasSelectNotificationsOptions[itemChildren.SelectType][0]?.value as string
                        : undefined
                    )}
                    disabled={itemChildren?.ValueSwitchDisabled}
                  />
                )}
                <span className="rowTitle">
                  {itemChildren.Title}
                </span>
              </span>
              {itemChildren.SelectType && (
                <span className="rowChange">
                  <Select
                    options={hasSelectNotificationsOptions[itemChildren.SelectType]}
                    value={itemChildren.ValueSelect}
                    size="small"
                    className="select"
                    disabled={(hasChecked && !itemChildren.ValueSwitch) || itemChildren?.ValueSelectDisabled}
                    notShowIcon={(hasChecked && !itemChildren.ValueSwitch) || itemChildren?.ValueSelectDisabled}
                    customBackgroundColor={theme.colors.secondary.secondary}
                    minheight={24}
                    minheighticon={-3.5}
                    righticon={6}
                    onChange={(value) => handleUpdate(itemChildren.Id, value)}
                  />
                </span>
              )}
            </div>
          </div>
        ))}
      </Content>
    </Container>
  )
}

export default CheckAndSelectTableItem
